module.exports = __webpack_public_path__ + "img/balance-date.e98d1255.png";